import { render, staticRenderFns } from "./ProductAccordion.vue?vue&type=template&id=035981a2&scoped=true&"
import script from "./ProductAccordion.vue?vue&type=script&lang=js&"
export * from "./ProductAccordion.vue?vue&type=script&lang=js&"
import style0 from "./ProductAccordion.vue?vue&type=style&index=0&id=035981a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035981a2",
  null
  
)

export default component.exports